import createLayoutBridge from '../lib/createLayoutBridge'

// Require all the files in `../layouts`, thanks webpack!
// https://github.com/webpack/docs/wiki/context#context-module-api
const requires = require.context('../layouts/', true, /\.js$/)

export default createLayoutBridge(requires)
